module.exports = __webpack_public_path__ + "img/cash-out.de85e25a.svg";